import { DOCUMENT } from '@angular/common';
import { Directive, HostBinding, HostListener, Inject } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {


  @HostBinding('autocomplete') public autocomplete
  constructor(@Inject(DOCUMENT) private document: Document) {
    this.autocomplete = 'off'
  }
  @HostListener('keypress', ['$event']) public disableKeys(e: any) {

    this.document.all ? e.keyCode : e.keyCode
    if (e.keyCode < 58 && e.keyCode > 47) {
      return true;
    }
    else {
      e.preventDefault()
      return false;
    }
  }
}